const protocol = window.location.protocol === 'https:' ? 'https:' : 'http:';
export const API_URL = process.env.REACT_APP_API_URL || `${protocol}//${window.location.hostname || 'localhost'}:5001`;
